import { formatPrice, isStrEmpty, getConfigSetup, getStateStore, isArrayEmpty, parseProxyObject, isObjEmpty, formatDateNoTimeZone } from '@/utils/utils';
import { formatDateUTC } from '@/utils/utils';
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [languageMixins],
    methods: {
        printSports(printParam, isReprint) {
            const configSetup = getConfigSetup();
            const store = parseProxyObject(this.$store.state);
            const isBluetooth = store.isBluetooth;

            const betStorage = JSON.parse(printParam);
            const voucher = betStorage[0].voucher;
            const transactions = betStorage[0].transactions;

            let printerData = {};

            if (!isStrEmpty(configSetup.logo)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            const elementReprint = {
                type: 'printTextCustom',
                value: this.getTranslatedText('reprint'),
                fontSize: 28,
                isBold: true,
                isUnderline: false,
                font: '',
                alignment: 1,
            }

            printerData['title'] = [
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText(configSetup.appName),
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
            ];

            if(isReprint) {
                printerData['title'].splice(2, 0, elementReprint)
            }

            for (const transaction of transactions) {
                let winningBeforeTax = formatPrice(parseFloat(transaction.winning_before_tax));
                let winningAfterTax = formatPrice(parseFloat(transaction.winning_after_tax));
                let withholdingTax = formatPrice(parseFloat(transaction.winnings_tax_amount));
                let tax = `${parseFloat(transaction.winnings_tax) * 100}%`;

                let totalOdds = formatPrice(parseFloat(transaction.odds_total));
                let wager = formatPrice(parseFloat(transaction.stake));

                const bets = transaction.bets;
                const formatDateVoucher = formatDateUTC(voucher.created_at)

                printerData['header'] = [
                    {
                        label: `${this.getTranslatedText('Date')}:`,
                        value: `${formatDateVoucher.year}-${formatDateVoucher.month}-${formatDateVoucher.day} ${formatDateVoucher.hour}:${formatDateVoucher.minutes}:${formatDateVoucher.seconds}`,
                        type: 'printTable',
                        column: isBluetooth ? [12, 20] : [2, 4],
                        align: [0, 2],
                        isBold: true,
                        isUnderline: false,
                    },
                    {
                        label: this.getTranslatedText('betslip ID'),
                        value: `${transaction.external_bet_id}`,
                        type: 'printTable',
                        column: isBluetooth ? [16, 16] : [2, 4],
                        align: [0, 2],
                        isBold: true,
                        isUnderline: false,
                    },
                ];

                let typeBeslip = '';

                if (transaction.bets.length > 1) {
                    typeBeslip = `---${this.getTranslatedText('Multiple')} : (${transaction.bets.length}) 'lines' ---`;
                } else {
                    typeBeslip = `----------- ${this.getTranslatedText('Simple')} -----------`;
                }

                printerData['titleBody'] = [
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printText',
                        value: typeBeslip,
                    },
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'setAlignLeft',
                    },
                ];

                let body = [];

                const fontSize = isBluetooth ? 18 : 24;

                for (var b = 0; b < bets.length; b++) {
                    let item = [
                        {
                            type: 'printTextCustom',
                            value: `${transaction.bets.length > 1 ? '[' + (b + 1) + '] ' : ''}${transaction.bets[b].tournament_name}\n`,
                            fontSize,
                            isBold: true,
                            isUnderline: false,
                            font: '',
                        },
                        {
                            type: 'printTextCustom',
                            value: `${bets[b].match_name_no_date || bets[b].match_name}`,
                            fontSize,
                            isBold: false,
                            isUnderline: false,
                            font: '',
                        },
                        {
                            type: 'printTextCustom',
                            value: `${bets[b].draw_time}`,
                            fontSize,
                            isBold: false,
                            isUnderline: false,
                            font: '',
                        },
                        {
                            type: 'printTextCustom',
                            value: `\n${bets[b].market_name}: ${bets[b].outcome_name} @ ${bets[b].odd}`,
                            fontSize,
                            isBold: true,
                            isUnderline: false,
                            font: '',
                        },
                    ];

                    if (b <= bets.length - 2) {
                        let items = {
                            type: 'printCutDashLine',
                        };

                        item.push(items);
                    }

                    body.push(...item);
                }

                const footer = [
                    {
                        type: 'printDashLine',
                    },
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printTable',
                        label: this.getTranslatedText('Total odds'),
                        value: totalOdds,
                        column: isBluetooth ? [16, 16] : [2, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: 'printTable',
                        label: this.getTranslatedText('stake'),
                        value: wager,
                        column: isBluetooth ? [16, 16] : [2, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: 'printTable',
                        label: this.getTranslatedText('Earnings before deduction'),
                        value: winningBeforeTax,
                        column: isBluetooth ? [16, 16] : [4, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: 'printTable',
                        label: this.getTranslatedText('Withholding [tax]', {
                            tax: tax,
                        }),
                        value: withholdingTax,
                        column: isBluetooth ? [20, 12] : [4, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: 'printTable',
                        label: this.getTranslatedText('Potential Earnings'),
                        value: winningAfterTax,
                        column: isBluetooth ? [20, 12] : [4, 2],
                        align: [0, 2],
                        isBold: true,
                    },
                    {
                        type: 'setAlignCenter',
                    },
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'barcode',
                        value: transaction.external_bet_id.startsWith('S-') ? transaction.external_bet_id : `S-${transaction.external_bet_id}`,
                        isShowCode: !isBluetooth,
                    },
                ];

                if(isReprint) {
                    footer.push(elementReprint)
                }

                if (isBluetooth) {
                    footer.push({
                        type: 'printEmptyLines',
                        line: 1,
                    });
                } else {
                    footer.push({
                            type: 'printEmptyLines',
                            line: 2,
                        },
                        {
                            type: 'cutPaper',
                        }
                    );
                }

                printerData['body'] = body;
                printerData['footer'] = footer;
            }

            parent.postMessage(
                {
                    command: 'print-common',
                    param: printerData,
                },
                '*',
            );
        },

        printSettle(printParam, isNumbers = false) {
            let printerData = {};

            const store = parseProxyObject(this.$store.state);
            const isBluetooth = store.isBluetooth;

            const configSetup = getConfigSetup();
            let date = formatDateUTC(printParam.date, 2);
            let datePrint = `${date.day}/${date.month}/${date.year} ${date.hour}:${date.minutes}`;
            if (!isStrEmpty(configSetup.logo)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            printerData['body'] = [
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'setAlignCenter',
                },
                !isStrEmpty(configSetup.appName) && {
                    type: 'printTextCustom',
                    value: isNumbers ? this.getTranslatedText('number betting') : this.getTranslatedText("LOTTO Limited"),
                    fontSize: 28,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: printParam?.isTestPrint ? this.getTranslatedText('test print') : this.getTranslatedText('receipt'),
                    fontSize: 28,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('date')}: ${datePrint}`,
                    fontSize: 28,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('branch')}: ${printParam.branch_name}`,
                    fontSize: 28,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('cashier')}: ${printParam.cashier_name}`,
                    fontSize: 28,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('code')}: ${printParam.code}`,
                    fontSize: 28,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('settlement')}: ${printParam.currency_code + ' ' + formatPrice(printParam.winnings)}`,
                    fontSize: 28,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    isCheckReplace: true
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'barcode',
                    value: printParam.code,
                    isShowCode: !isBluetooth,
                },
                {
                    type: 'cutPaper',
                },
            ];


            if(printParam.winnings.toString().length > 6) {

                const indexToReplace = printerData['body'].findIndex(
                    (item) => item?.isCheckReplace
                );

                const newColumn = [
                    {
                        type: 'setAlignLeft',
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('settlement')}: `,
                        fontSize: 28,
                        isBold: true,
                        isUnderline: false,
                        font: '',
                        isCheckReplace: true
                    },
                    {
                        type: 'setAlignRight',
                    },
                    {
                        type: 'printTextCustom',
                        value: `${printParam.currency_code + ' ' + formatPrice(printParam.winnings)}`,
                        fontSize: 28,
                        isBold: true,
                        isUnderline: false,
                        font: '',
                        isCheckReplace: true
                    },
                    {
                        type: 'setAlignCenter',
                    },

                ]
                printerData['body'].splice(indexToReplace, 1, ...newColumn);
            }

            if (isBluetooth) {
                printerData.body.push({
                    type: 'printEmptyLines',
                    line: 1,
                });
            }

            parent.postMessage(
                {
                    command: 'print-common',
                    param: printerData,
                },
                '*',
            );
        },

        printReport(printParam) {
            let printerData = {};

            const store = parseProxyObject(this.$store.state);
            const isBluetooth = store.isBluetooth;

            const configSetup = getConfigSetup();
            const CURRENCY = configSetup.currency;
            const { displays, summary } = printParam;

            let currentDate = formatDateUTC(new Date(), 2);
            let printDate = `${currentDate.day}/${currentDate.month}/${currentDate.year}`;

            let today = `${currentDate.year}-${currentDate.month}-${currentDate.day}`;
            let reports = printParam.report.filter((item) => item['product_type']);
            let reportParams = [];
            // to do report
            reports.forEach((r) => {
                let item = [
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${r.product_type}`,
                        fontSize: 24,
                        isBold: true,
                        isUnderline: false,
                        font: '',
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('stake')}: ${formatPrice(parseFloat(r.wagers))}`,
                        fontSize: 24,
                        isBold: false,
                        isUnderline: false,
                        font: '',
                    },
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('payouts')}: ${formatPrice(parseFloat(r.payouts))}`,
                        fontSize: 24,
                        isBold: false,
                        isUnderline: false,
                        font: '',
                    },
                ];

                reportParams.push(...item);
            });

            if (!isStrEmpty(configSetup.logo)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            printerData['body'] = [
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: printParam.isFinal ? this.getTranslatedText('final report of') : this.getTranslatedText('report of'),
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${printParam.localCashier.first_name} ${printParam.localCashier.last_name}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('report date')}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${printParam.date}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('print date')}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${printDate}`,
                    fontSize: 30,
                    isBold: false,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('summary')}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
            ];

            let reportSummary = [];
            const keyIsBold = ['cash_difference', 'true_balance'];

            displays?.forEach((dItem) => {
                const item = {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText(dItem.name)}: ${CURRENCY} ${formatPrice(parseFloat(summary[dItem.field] || 0))}`,
                    fontSize: 24,
                    isBold: keyIsBold.includes(dItem.field) ? true : false,
                    isUnderline: false,
                    font: '',
                }

                reportSummary.push(item);
            })

            printerData['body'].push(...reportSummary, ...reportParams);

            if (isBluetooth) {
                printerData['body'].push({
                    type: 'printEmptyLines',
                    line: 2,
                });
            } else {
                printerData['body'].push({
                    type: 'cutPaper',
                });
            }

            parent.postMessage(
                {
                    command: 'print-common',
                    param: printerData,
                },
                '*',
            );
        },

        printNumber(param) {
            const store = parseProxyObject(this.$store.state);
            const isBluetooth = store.isBluetooth;

            const configSetup = getConfigSetup();
            const printerData = {};
            const dataP = JSON.parse(param);

            if (!isStrEmpty(configSetup.logo)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            printerData['title'] = [
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('NUMBERS BETTING')}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
            ];

            const transaction = dataP.transaction;
            const cashierInfo = dataP.additional_information;

            const cashierName = !isStrEmpty(cashierInfo.cashier_name_for_printer) ? cashierInfo.cashier_name_for_printer : '';

            printerData['header'] = [
                {
                    label: `${this.getTranslatedText('Date')}: `,
                    value: formatDateNoTimeZone(dataP.bet_created_date),
                    type: 'printTable',
                    column: isBluetooth ? [12, 20] : [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Cashier')}: `,
                    value: cashierName,
                    type: 'printTable',
                    column: isBluetooth ? [12, 20] : [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Betslip ID')}: `,
                    value: dataP.transaction.transaction_id,
                    type: 'printTable',
                    column: isBluetooth ? [16, 16] : [3, 3],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
            ];

            const products = dataP.products;
            const body = [];

            let totalBets = 0;

            const fontSize = isBluetooth ? 18 : 24;

            for (let index = 0; index < products.length; index++) {
                const element = products[index];
                const itemBody = [
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printDashLine',
                    },
                    {
                        type: 'setAlignLeft',
                    },
                    {
                        type: 'printEmptyLines',
                        line: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: element.name,
                        fontSize,
                        isBold: true,
                        isUnderline: false,
                        font: '',
                        alignment: 1,
                    },
                ];

                for (let indexBet = 0; indexBet < element.bets.length; indexBet++) {
                    const elementBet = element.bets[indexBet];

                    let itemBet = [
                        {
                            type: 'printTextCustom',
                            value: this.renderDatePrint(elementBet.draw_date),
                            fontSize,
                            isBold: true,
                            isUnderline: false,
                            font: '',
                            alignment: 1,
                        },
                        {
                            type: 'setBold',
                            isBoid: false,
                        },
                    ];
                    itemBody.push(...itemBet);

                    for (let indexEntries = 0; indexEntries < elementBet.entries.length; indexEntries++) {
                        totalBets++;
                        const elementEntries = elementBet.entries[indexEntries];

                        const numbers = elementEntries.bet.numbers;
                        const summary = elementEntries.bet.summary;
                        let pickText = elementEntries.bet.text;
                        if (!isArrayEmpty(numbers)) {
                            const main = numbers[0].join('-');
                            const bonus = numbers[1].join('-');
                            pickText = main + ' ' + bonus;
                        }

                        const paid = formatPrice(elementEntries.paid);
                        const potentialWinings = formatPrice(elementEntries.total_potential_winnings);

                        const itemEntries = [
                            {
                                type: 'printTextCustom',
                                value: summary,
                                fontSize,
                                isBold: true,
                                isUnderline: false,
                                font: '',
                                alignment: 0,
                            },
                            {
                                type: 'printTextCustom',
                                value: pickText,
                                fontSize,
                                isBold: true,
                                isUnderline: false,
                                font: '',
                                alignment: 1,
                            },
                            {
                                label: `${this.getTranslatedText('paid')}: `,
                                value: paid,
                                type: 'printTable',
                                column: isBluetooth ? [14, 18] : [2, 4],
                                align: [0, 2],
                                isBold: true,
                                isUnderline: false,
                            },
                            {
                                label: `${this.getTranslatedText('Possible Winnings')}: `,
                                value: potentialWinings,
                                type: 'printTable',
                                column: isBluetooth ? [20, 12] : [2, 4],
                                align: [0, 2],
                                isBold: true,
                                isUnderline: false,
                            },
                        ];

                        if (elementBet.entries.length - 1 > indexEntries) {
                            itemEntries.push({
                                type: 'printCutDashLine',
                            });
                        }

                        itemBody.push(...itemEntries);
                    }
                }
                body.push(...itemBody);
            }

            const footer = [
                {
                    type: 'setBold',
                    isBoid: true,
                },
                {
                    type: 'printDashLine',
                },
                {
                    type: 'printTable',
                    label: `${this.getTranslatedText('Total Bet Amount')}:`,
                    value: formatPrice(transaction.amount),
                    column: isBluetooth ? [20, 12] : [4, 2],
                    align: [0, 2],
                    isBold: true,
                },
                {
                    type: 'printTable',
                    label: `${this.getTranslatedText('Total Bets')}:`,
                    value: totalBets,
                    column: isBluetooth ? [16, 16] : [2, 2],
                    align: [0, 2],
                    isBold: true,
                },
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'barcode',
                    value: transaction.transaction_id,
                    isShowCode: !isBluetooth,
                },
                // {
                //     type: "printTextCustom",
                //     value: transaction.transaction_id,
                //     fontSize: 24,
                //     isBold: true,
                //     isUnderline: false,
                //     font: "",
                //     alignment: 1,
                // },
                // {
                //     type: 'printEmptyLines',
                //     line: 2,
                // },
                {
                    type: 'cutPaper',
                }
            ];

            printerData['body'] = body;
            printerData['footer'] = footer;

            parent.postMessage(
                {
                    command: 'print-common',
                    param: printerData,
                },
                '*',
            );
        },

        printTest() {
            const configSetup = getConfigSetup();

            const printerData = {};

            if (!isStrEmpty(configSetup.logo)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            printerData['title'] = [
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('NUMBERS BETTING')}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('NUMBERS BETTING')}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: `${this.getTranslatedText('NUMBERS BETTING')}`,
                    fontSize: 30,
                    isBold: true,
                    isUnderline: false,
                    font: '',
                    alignment: 1,
                },
                {
                    type: 'cutPaper',
                },
            ];

            parent.postMessage(
                {
                    command: 'print-common',
                    param: printerData,
                },
                '*',
            );
        },

        printLoto(param) {
            const configSetup = getConfigSetup();
            // const font = this.isMobiDevice() ? "1" : "";
            const printerData = {};

            if (!isStrEmpty(configSetup.logo)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }
            const dateFormat = formatDateUTC(new Date(), 2);
            const print_date = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            let ticket_code = param.id;

            if (!isStrEmpty(ticket_code)) {
                if (!ticket_code.toString().startsWith('L-')) ticket_code = 'L-' + ticket_code;
            }

            printerData['header'] = [
                {
                    type: 'printEmptyLines',
                    line: 2,
                },
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText(param.title.toLowerCase()),
                    fontSize: 25,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    label: `${this.getTranslatedText('Date')}:`,
                    value: print_date,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Id ticket')}:`,
                    value: ticket_code,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isUnderline: false,
                },
            ];

            const body = [
                {
                    type: 'setAlignLeft',
                },
            ];
            for (let index = 0; index < param.tickets.length; index++) {
                const element = param.tickets[index];

                let numberTicket = element.selection_bet[0].join(', ');
                if (element.selection_bet[1]) {
                    numberTicket = numberTicket + ' - ' + element.selection_bet[1].join(', ');
                }

                const itemBody = [
                    {
                        type: 'printCutDashLine',
                    },
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText(element.game_name),
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: numberTicket,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        label: `${this.getTranslatedText('stake')}:`,
                        value: `${formatPrice(parseFloat(element.wager))}`,
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('draw name')}:`,
                        value: this.getTranslatedText(element.loto_name),
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('draw date')}:`,
                        value: element.draw_date,
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                ];

                body.push(...itemBody);
            }

            const bodyFooter = [
                {
                    type: 'printDashLine',
                },
            ];

            body.push(...bodyFooter);

            printerData['body'] = body;

            printerData['footer'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'setFontSize',
                    size: 30,
                },
                {
                    label: `${this.getTranslatedText('total')}:`,
                    value: `${formatPrice(param.total_tickets, 2)} ${param.currency}`,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isBold: true,
                    isUnderline: false,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'barcode',
                    value: ticket_code,
                    isShowCode: true,
                },
                {
                    type: 'cutPaper',
                },
            ];

            parent.postMessage({ command: 'print-common', param: printerData }, '*');
        },

        printLottoDaily(param, isReprint) {
            const configSetup = getConfigSetup();
            const state = getStateStore();
            const printerData = {};

            if (!isStrEmpty(configSetup?.logoPrint)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            const dateFormat = formatDateUTC(new Date(), 2);
            const print_date = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            let ticket_code = param?.transaction?.external_id;

            if (!isStrEmpty(ticket_code)) {
                if (!ticket_code.toString().startsWith('L-')) ticket_code = 'L-' + ticket_code;
            }

            const elementReprint = {
                type: 'printTextCustom',
                value: this.getTranslatedText('reprint'),
                fontSize: 24,
                isBold: true,
                isUnderline: false,
                font: '',
                alignment: 1,
            }

            printerData['header'] = [
                {
                    type: 'printEmptyLines',
                    line: 2,
                },
                {
                    type: 'setFontSize',
                    size: 22,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText("GAB LOTTO Limited"),
                    fontSize: 24,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    label: `${this.getTranslatedText('Terminal ID')}:`,
                    value: state?.userInfo?.terminalId || '',
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Sales Time')}:`,
                    value: print_date,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Ticker Number')}:`,
                    value: ticket_code,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                }
            ];

            if(isReprint) {
                printerData['header'].push(elementReprint)
            }

            const body = [
                {
                    type: 'printCutDashLine',
                },
            ];
            for (let index = 0; index < param.bets.entries.length; index++) {
                const element = param.bets.entries[index];
                let numberTicket = element.entry.bet[0].join(', ');
                if (element.entry.bet[1]) {
                    numberTicket = numberTicket + ' - ' + element.entry.bet[1].join(', ');
                }

                let itemBody = [
                    {
                        type: 'setAlignCenter',
                    },
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText(element.market.market),
                        fontSize: 24,
                        isUnderline: false,
                        alignment: 1,
                        isBold: true,
                    },
                    {
                        type: 'printTextCustom',
                        value: numberTicket,
                        fontSize: 26,
                        isUnderline: true,
                        alignment: 1,
                        isBold: true,
                    },
                    {
                        type: 'printTextCustom',
                        value: '',
                        fontSize: 26,
                        isUnderline: false,
                        alignment: 1,
                        isBold: true,
                    },
                    {
                        type: 'setAlignLeft',
                    },
                    {
                        type: 'setFontSize',
                        size: 23,
                    },
                    {
                        type: 'setBold',
                        isBoid: false
                    },
                    ...((element.entry?.market_option || element.market?.marketOption) ? [{
                        label: `${this.getTranslatedText('Bet Option')}:`,
                        value: this.getTranslatedText((element.entry?.market_option || element.market?.marketOption) === 'machine_number' ? 'Machine Number' : 'Normal'),
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    }] : []),
                    {
                        label: `${this.getTranslatedText('stake')}:`,
                        value: `${formatPrice(parseFloat(element.entry.totalWager))}`,
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('game name')}:`,
                        value: this.getTranslatedText(element.event.drawName),
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('draw date')}:`,
                        value: this.renderDatePrint(element.event.drawDate),
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('Number Lines')}:`,
                        value: element.entry.combinations,
                        type: 'printTable',
                        column: [4, 2],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('Possible Winnings')}:`,
                        value: `${formatPrice(element.entry.potentialWinnings)}`,
                        type: 'printTable',
                        column: [4, 2],
                        align: [0, 2],
                        isUnderline: false,
                    },
                ];

                if(element.entry.potentialWinnings.length > 9) {
                    itemBody = itemBody.slice(0, -1)
                    const newColumn = [
                        {
                            label: `${this.getTranslatedText('Possible Winnings')}:`,
                            value: ``,
                            type: 'printTable',
                            column: [4, 2],
                            align: [0, 2],
                            isUnderline: false,
                        },{
                            label: ``,
                            value: `${formatPrice(element.entry.potentialWinnings)}`,
                            type: 'printTable',
                            column: [2, 4],
                            align: [0, 2],
                            isUnderline: false,
                        },
                    ]
                    itemBody.push(...newColumn)
                }

                body.push(...itemBody);
            }

            const bodyFooter = [
                {
                    type: 'printDashLine',
                },
            ];

            body.push(...bodyFooter);

            printerData['body'] = body;

            const winningPayoutExpired = parseInt(state.config?.winning_payout_expired.toString() || '1');

            const dateAddDate = formatDateUTC(new Date(), 2, winningPayoutExpired);
            const print_date_after = `${dateAddDate.day}/${dateAddDate.month}/${dateAddDate.year}`;

            printerData['footer'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'setFontSize',
                    size: 30,
                },
                {
                    type: 'setBold',
                    isBoid: true
                },
                {
                    label: `${this.getTranslatedText('total')}:`,
                    value: `${formatPrice(param.transaction.total, 2)} ${param.transaction.currency}`,
                    type: 'printTable',
                    column: [2, 4],
                    align: [0, 2],
                    isUnderline: false,
                },
            ];

            if(isReprint) {
                printerData['footer'].splice(5, 0, elementReprint)
            }

            if (param.raffle_print_data && param.raffle_print_data.length > 0) {
                printerData['footer'].push({
                    type: 'printDashLine',
                })
                printerData['footer'].push({
                    type: 'printEmptyLines',
                    line: 1,
                })

                printerData['footer'] = printerData['footer'].concat([
                    {
                        type: 'printTextCustom',
                        value: `${this.getTranslatedText('raffle entry code')}`,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: param.raffle_code,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    },
                ]);

                param.raffle_print_data.forEach(e => {
                    let str = this.getTranslatedText(e.text)
                    if (e.replaces && e.replaces.length > 0) {
                        // format string
                        e.replaces.forEach(s => {
                            str = str.replace('%s', s)
                        })
                    }

                    printerData['footer'].push({
                        type: 'printTextCustom',
                        value: str,
                        fontSize: 25,
                        isUnderline: false,
                        alignment: 1,
                    })
                });
                printerData['footer'].push({
                    type: 'printDashLine',
                })
            }

            const itemNoteFooter = [
                {
                    type: 'setBold',
                    isBoid: false
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'barcode',
                    value: ticket_code,
                    isShowCode: true,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('Good Luck'),
                    fontSize: 26,
                    isUnderline: false,
                    alignment: 1,
                    isBold: true
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText(`This is valid for [date] days ending`, {
                        date: winningPayoutExpired,
                    }),
                    fontSize: 24,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: print_date_after,
                    fontSize: 24,
                    isUnderline: false,
                    alignment: 1,
                },
            ]

            printerData['footer'].push(...itemNoteFooter)

            if(!isStrEmpty(configSetup?.whatsApp)) {
                const whatsApp = [
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText('Customer care line (whatsapp)'),
                        fontSize: 24,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: configSetup?.whatsApp,
                        fontSize: 24,
                        isUnderline: false,
                        alignment: 1,
                    },
                ]
                printerData['footer'].push(...whatsApp)
            }

            printerData['footer'].push({
                type: 'cutPaper',
            });

            parent.postMessage({ command: 'print-common', param: printerData }, '*');
        },

        printLottoInstant(param, isReprint) {
            const configSetup = getConfigSetup();
            const state = getStateStore();
            const printerData = {};

            if (!isStrEmpty(configSetup?.logoPrint)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            const dateFormat = formatDateUTC(new Date(), 2);
            const print_date = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            let ticket_code = param?.transaction?.external_id;

            if (!isStrEmpty(ticket_code)) {
                if (!ticket_code.toString().startsWith('L-')) ticket_code = 'L-' + ticket_code;
            }

            const elementReprint = {
                type: 'printTextCustom',
                value: this.getTranslatedText('reprint'),
                fontSize: 24,
                isBold: true,
                isUnderline: false,
                font: '',
                alignment: 1,
            };

            printerData['header'] = [
                {
                    type: 'printEmptyLines',
                    line: 2,
                },
                {
                    type: 'setFontSize',
                    size: 22,
                },
                {
                    label: `${this.getTranslatedText('Terminal ID')}:`,
                    value: state?.userInfo?.terminalId || '',
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Sales Time')}:`,
                    value: print_date,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Ticker Number')}:`,
                    value: ticket_code,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    type: 'printDashLine',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
            ];

            if (isReprint) {
                printerData['header'].push(elementReprint);
            }

            printerData['body'] = [];
            let winnings = 0;
            let wager = 0;
            for (let index = 0; index < param.bets.entries.length; index++) {
                const element = param.bets.entries[index];

                winnings += parseFloat(element.winnings);
                wager += parseFloat(element.entry.wager);

                const gameName = this.getTranslatedText(element.game.game)?.toUpperCase();

                const drawDateFormat = formatDateUTC(new Date());

                const drawDate = `${drawDateFormat.day}/${drawDateFormat.month}/${drawDateFormat.year} ${drawDateFormat.hour}:${drawDateFormat.minutes}`;

                const dataBet = element.entry.bet[0];

                const itemBody = [
                    {
                        type: 'printTextCustom',
                        value: gameName,
                        fontSize: 30,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText('Your numbers'),
                        fontSize: 28,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: dataBet,
                        fontSize: 26,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'setFontSize',
                        size: 24,
                    },
                    {
                        label: `${this.getTranslatedText('game name')}:`,
                        value: element.event.drawName,
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('draw date')}:`,
                        value: drawDate,
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText('draw number'),
                        fontSize: 28,
                        isUnderline: false,
                        alignment: 1,
                    },
                ];

                const result = !isStrEmpty(element.result) ? JSON.parse(element.result) : [];
                for (let i = 0; i < result.length; i += 5) {
                    const columnResult = {
                        type: 'printTextCustom',
                        value: result.slice(i, i + 5).join(' '),
                        fontSize: 26,
                        isUnderline: false,
                        alignment: 1,
                    };
                    itemBody.push(columnResult);
                }

                const itemPrice = [
                    {
                        type: 'setFontSize',
                        size: 26,
                    },
                    {
                        label: `${this.getTranslatedText('stake')}:`,
                        value: `${formatPrice(element.entry.wager)}`,
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('winnings')}:`,
                        value: `${formatPrice(element.winnings)}`,
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                    },
                ];

                itemBody.push(...itemPrice);

                if (param.bets.entries.length - 1 !== index) {
                    itemBody.push({
                        type: 'printEmptyLines',
                        line: 1,
                    });
                }

                printerData['body'].push(...itemBody);
            }

            const winningPayoutExpired = parseInt(state.config?.winning_payout_expired.toString() || '1');

            const dateAddDate = formatDateUTC(new Date(), 2, winningPayoutExpired);
            const print_date_after = `${dateAddDate.day}/${dateAddDate.month}/${dateAddDate.year}`;

            printerData['footer'] = [
                {
                    type: 'printDashLine',
                },
                {
                    type: 'setFontSize',
                    size: 24,
                },
                {
                    label: `${this.getTranslatedText('Total Stake')}:`,
                    value: `${formatPrice(wager)}`,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    label: `${this.getTranslatedText('Total Winnings')}:`,
                    value: `${formatPrice(winnings)}`,
                    type: 'printTable',
                    column: [3, 3],
                    align: [0, 2],
                    isUnderline: false,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'setFontSize',
                    size: 30,
                },
                {
                    type: 'setBold',
                    isBoid: true,
                },
                {
                    type: 'barcode',
                    value: ticket_code,
                    isShowCode: true,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('Good Luck'),
                    fontSize: 26,
                    isUnderline: false,
                    alignment: 1,
                    isBold: true,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText(`This is valid for [date] days ending`, {
                        date: winningPayoutExpired,
                    }),
                    fontSize: 24,
                    isUnderline: false,
                    alignment: 1,
                },
                {
                    type: 'printTextCustom',
                    value: print_date_after,
                    fontSize: 24,
                    isUnderline: false,
                    alignment: 1,
                },
            ];

            if (isReprint) {
                printerData['footer'].splice(5, 0, elementReprint);
            }

            if (!isStrEmpty(configSetup?.whatsApp)) {
                const whatsApp = [
                    {
                        type: 'printTextCustom',
                        value: this.getTranslatedText('Customer care line (whatsapp)'),
                        fontSize: 24,
                        isUnderline: false,
                        alignment: 1,
                    },
                    {
                        type: 'printTextCustom',
                        value: configSetup?.whatsApp,
                        fontSize: 24,
                        isUnderline: false,
                        alignment: 1,
                    },
                ];
                printerData['footer'].push(...whatsApp);
            }

            printerData['footer'].push({
                type: 'cutPaper',
            });

            parent.postMessage({ command: 'print-common', param: printerData }, '*');
        },

        printResult(data) {
            const configSetup = getConfigSetup();

            const printerData = {};

            if (!isStrEmpty(configSetup?.logoPrint)) {
                printerData['logo'] = this.resetCacheLogoPrint(configSetup.logoPrint);
            }

            printerData['header'] = [
                {
                    type: 'setAlignCenter',
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printTextCustom',
                    value: this.getTranslatedText('result'),
                    fontSize: 30,
                    isBold: true,
                    alignment: 1,
                },
                {
                    type: 'printEmptyLines',
                    line: 1,
                },
                {
                    type: 'printDashLine',
                },
            ];

            const body = [];

            for (let i = 0; i < data.length; i++) {
                const resultItem =  data[i]

                let result = "";
                let machineNumber = "";

                if (resultItem.results && resultItem.results[0]) {
                    result += resultItem.results[0];
                }
                if (resultItem.results && resultItem.results[1]) {
                    result += "," + resultItem.results[1];
                }

                if(resultItem.machine_results && resultItem.machine_results[0]) {
                    machineNumber += resultItem.machine_results[0];
                }

                if(resultItem.machine_results && resultItem.machine_results[1]) {
                    machineNumber += "," + resultItem.machine_results[1];
                }

                let itemBody = [
                    {
                        label: `${this.getTranslatedText('Draw date')}:`,
                        value: this.renderDatePrint(resultItem.draw_date),
                        type: 'printTable',
                        column: [2, 4],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        label: `${this.getTranslatedText('Draw name')}:`,
                        value: resultItem.draw_name,
                        type: 'printTable',
                        column: [3, 3],
                        align: [0, 2],
                        isUnderline: false,
                    },
                    {
                        type: "printTextCustom",
                        value: `${this.getTranslatedText('winning Numbers')}`,
                        alignment: 2,
                    },
                    {
                        type: "printTextCustom",
                        value: `${result.replace(/,/g, ', ')}`,
                        isBold: true,
                        alignment: 2,
                    },
                ];

                if(!isStrEmpty(machineNumber)) {
                    const itemMachine = [
                        {
                            type: "printTextCustom",
                            value: `${this.getTranslatedText('Machine Numbers')}`,
                            alignment: 2,
                        },
                        {
                            type: "printTextCustom",
                            value: `${machineNumber.replace(/,/g, ', ')}`,
                            alignment: 2,
                        },
                    ];
                    itemBody.push(...itemMachine)
                }

                itemBody.push({type: "printDashLine",})

                body.push(...itemBody);
            }
            printerData['body'] = body;

            printerData['footer'] = [
                {
                    type: 'cutPaper',
                },
            ];
            parent.postMessage({ command: 'print-common', param: printerData }, '*');
        },

        resetCacheLogoPrint(logo) {
            const timestamp = new Date().getTime();
            return `${logo}?v=${timestamp}`
        },

        renderDatePrint(date) {
            const dateFormat = formatDateUTC(date, 2);
            let valueDate = `${dateFormat.year}-${dateFormat.month}-${dateFormat.day} ${dateFormat.hour}:${dateFormat.minutes}:${dateFormat.seconds}`;

            return valueDate;
        },

        isMobiDevice() {
            const state = getStateStore();
            let device = state.configDevice;

            if (device?.serial?.startsWith('tb8765ap1_64_bsp')) {
                return true;
            }
            return false;
        },
    },
};
